import posthog from 'posthog-js';
import { createStripeCheckoutSession } from '../api/axios';
import { STRIPE_URLS } from '../constants/urls';

// Function to initiate subscription checkout
export const initiateCheckout = async (
  productId: string = process.env.REACT_APP_COLOR_CACHE_PRODUCT_ID || '',
  priceId: string = process.env.REACT_APP_COLOR_CACHE_SUBSCRIPTION_PRICE_ID ||
    ''
) => {
  try {
    const checkoutSession = await createStripeCheckoutSession(
      productId,
      priceId,
      STRIPE_URLS.SUCCESS_URL,
      STRIPE_URLS.CANCEL_URL,
      1
    );

    // Redirect to Stripe checkout
    if (checkoutSession.url) {
      posthog.capture('checkout_initiated', { product_id: productId, price_id: priceId, quantity: 1 });
      window.location.href = checkoutSession.url;
    }

    return checkoutSession;
  } catch (error) {
    console.error('Failed to create checkout session:', error);
    posthog.captureException(error);
    throw error;
  }
};

// Function with custom URLs for subscription checkout
export const initiateCheckoutWithCustomUrls = async (
  productId: string,
  priceId: string,
  successUrl: string,
  cancelUrl: string,
  quantity: number = 1,
  metadata?: Record<string, any>
) => {
  try {
    const checkoutSession = await createStripeCheckoutSession(
      productId,
      priceId,
      successUrl,
      cancelUrl,
      quantity,
      metadata
    );

    // Redirect to Stripe checkout
    if (checkoutSession.url) {
      posthog.capture('checkout_initiated', {
        product_id: productId,
        price_id: priceId,
        quantity,
      });
      window.location.href = checkoutSession.url;
    }

    return checkoutSession;
  } catch (error) {
    console.error('Failed to create checkout session:', error);
    posthog.captureException(error);
    throw error;
  }
};
